module.exports = __webpack_public_path__ + "static/visible_focus-97ece038f15ad2f90fea899dbb7113f6.png";